import Vue from 'vue'
import { VPopover } from 'v-tooltip'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
Vue.component('v-popover', VPopover)